module.exports = "/images/enterprise.svg?fd1c24dc5cca31082a65a92a4da0b30d";


//////////////////
// WEBPACK FOOTER
// ./resources/images/icons/enterprise.svg
// module id = I1r+
// module chunks = 0 1